import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentdate;

  constructor() { }

  ngOnInit() {
    const cdate = new Date();

    this.currentdate = cdate.getFullYear();
  }

}
